import RemoveBannerDialog from "./removeBannerDialog.container";

export default RemoveBannerDialog
